<script setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'


const route = useRoute()
const results = ref([])
const error = ref('')



const fetchResults = async () => {
  const search = route.query.search
  if (!search) return

  try {

    const res = await axios.get('https://fixstyle.ir/api/Search', { params: { search } })
    // const response = await axios.get('https://picsum.photos/v2/list')
    /*const response = await axios.get('https://fixstyle.ir/api/user',{
      headers: {
        Authorization: `Bearer ${store.getters.getToken}`
      }
    })*/
    results.value = res.data.data
    console.log(res)
  } catch (err) {
    error.value= 'خطا در دریافت اطلاعات'+err.message
    console.error(err.message)
  } finally {
    // loading.value = false
  }


}

const truncate = (text, length = 40) => {
  if (!text) return ''
  return text.length > length ? text.slice(0, length) + '...' : text
}


onMounted(fetchResults)
watch(() => route.query.search, fetchResults)
</script>

<template>
  <div>
    <h2>نتایج جستجو برای "{{ route.query.search }}"</h2>
    <p>{{ error }}</p>
    <div class="row row-cols-sm-2 row-cols-lg-4">
      <div class="col my-2" v-for="item in results" :key="item.id">
        <div  class="card" >

          <img class="card-img-top" :src="'https://fixstyle.ir/img/product/thumbnails/'+item.images.url" :alt="item.name ">

          <div class="card-body">
            <h5 class="card-title"><a href="/product/1" class="">{{ item.name }}({{ item.id }})</a> </h5>
            <p class="card-text" v-html="truncate(item.description)"></p>
          </div>



        </div>
      </div>

    </div>
  </div>
</template>

<style scoped>

</style>